export const registrationAPI = {
  application: {
    eduInfo: {
      university: "",
      degreeType: "",
      year: "",
      city: "",
      campus: "",
      campusSpecific: "",
      fee: "",
      duration: "",
      disability: [],
      orphan: "",
      admissionLetter: "",
      paymentReciept:"",
    },
    incomeInfo: {
      earningMember: true,
      membersList: [],
    },
    personalInfo: {
      firstName: "",
      photo: "",
      mobile: "",
      email: "",
      experience: "",
      gender: "",
      dob: "",
      address: [
        {
          address1: "",
          address2: "",
          city: "",
          state: "",
          pin: "",
          // addressProof: "aadhaar",
          addressType: "PERMANENT",
        },
        {
          address1: "",
          address2: "",
          city: "",
          state: "",
          pin: "",
          addressProof: "",
          addressType: "TEMPORARY",
        },
      ],
    },
  },
  registration: {
    source: "",
    college: "",
    degree: "",
    year: "",
    income: true,
    family: true,
    indian: true,
    aadhaar: "",
    mobile: "",
    email: "",
    isDob: false
    // password: "@12345abc",
  },
};
